// Mock data for Northwest Haul Rentals

export const brand = {
  name: 'Northwest Haul Rentals',
  short: 'Northwest Haul',
  tagline: 'Haul Smart. Rent Local.',
  phone: '(360) 500-2004',
  phoneRaw: '3605002004',
  email: 'northwesthaulrentals@gmail.com',
  owner: 'Jason',
  city: 'Olympia, WA',
  street: '3920 113th Ave SW',
  cityLine: 'Olympia, WA 98512',
  address: '3920 113th Ave SW, Olympia, WA 98512',
  hours: 'Mon–Sun · 7:00 AM – 9:00 PM',
};

export const nav = [
  { label: 'Home', href: '#home' },
  { label: 'Trailers', href: '#trailers' },
  { label: 'How It Works', href: '#how' },
  { label: 'Requirements', href: '#requirements' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Contact', href: '#contact' },
];

export const heroImages = {
  primary: 'https://images.unsplash.com/photo-1730514785075-b065c757b653?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHx0cnVjayUyMHRvd2luZ3xlbnwwfHx8fDE3ODUxMDcxNDN8MA&ixlib=rb-4.1.0&q=85',
  secondary: 'https://images.unsplash.com/photo-1626121300305-def4dc305387?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHx0cnVjayUyMHRvd2luZ3xlbnwwfHx8fDE3ODUxMDcxNDN8MA&ixlib=rb-4.1.0&q=85',
};

// The 4 real trailers currently in the fleet
export const trailers = [
  {
    id: 'maxxd-c4x-7k',
    name: 'MAXX-D C4X 7K Car Hauler',
    manufacturer: 'MAXX-D (Maxey Trailers)',
    model: 'C4X 7K Channel',
    year: '2022',
    category: 'Car Hauler',
    tag: 'Most Popular',
    image: '/trailers/ai/maxxd-c4x-7k.jpg',
    gallery: [
      '/trailers/ai/maxxd-c4x-7k.jpg',
      '/trailers/maxxd-c4x-wood.jpg',
      '/trailers/utility-mesh-back.jpg',
    ],
    gvwr: '7,000 lbs',
    gawr: '3,500 lbs / axle',
    axles: 'Tandem 3,500 lb brake axles',
    deck: '2×8 treated wood',
    dimensions: '19′3″ L × 6′10″ W cargo area',
    payload: '5,100 lbs max',
    bestFor: ['Cars & light trucks', 'ATVs & UTVs', 'Small equipment', 'Flatbed hauls'],
    features: [
      '5″ channel main frame + wrap tongue',
      'Slide-in rear ramps',
      'Double-broke diamond-plate fenders',
      'Stake pockets + rub rail',
      '7K drop-leg jack',
      'LED lighting, dual spare tires included',
    ],
    pricing: { hourly: 20, weekday: 135, weekend: 165, weekly: 750, monthly: 1575 },
  },
  {
    id: 'continental-cargo',
    name: 'Continental Enclosed Cargo',
    manufacturer: 'Continental Cargo',
    model: 'Bumper-pull Enclosed',
    year: null,
    category: 'Cargo',
    tag: 'Best Value',
    image: '/trailers/real/continental-nhr.jpg',
    gallery: [
      '/trailers/real/continental-nhr.jpg',
      '/trailers/real/fleet-group.jpg',
      '/trailers/real/continental-rear.webp',
    ],
    gvwr: '2,990 lbs',
    gawr: '3,500 lbs / axle',
    axles: 'Single axle',
    deck: 'Fully enclosed weather-proof',
    dimensions: '6′ H × 10′ L × 5′7″ W cargo area',
    payload: '2,040 lbs max',
    bestFor: ['Secure moves', 'Weather-sensitive loads', 'Motorcycles', 'Small vehicles'],
    features: [
      'Fully enclosed weather-proof body',
      'Rear ramp / barn-door access',
      'E-track on walls',
      'Interior stock lighting + battery-powered LED lighting system',
      'Lockable for high-value hauls',
    ],
    pricing: { hourly: 20, weekday: 90, weekend: 120, weekly: 525, monthly: 2250 },
  },
  {
    id: 'olympic-utility',
    name: 'Olympic Open Utility',
    manufacturer: 'Olympic',
    model: 'Single-axle Utility',
    year: null,
    category: 'Utility',
    tag: null,
    image: '/trailers/real/utility-1.jpg',
    gallery: ['/trailers/real/utility-1.jpg', '/trailers/real/utility-2.jpg'],
    gvwr: '2,990 lbs',
    gawr: '3,500 lbs',
    axles: 'Single axle',
    deck: 'Open box',
    dimensions: '3′ H sides × 14′ L × 5′7″ W',
    payload: '2,000 lbs max',
    bestFor: ['Furniture & appliances', 'Lawn equipment', 'General cargo', 'Light construction'],
    features: [
      'Swing-out rear gate (not ramp style)',
      'A-frame tongue with swivel jack',
      'Single axle with fenders',
      'Safety chains included',
      'Better weather protection than mesh',
    ],
    pricing: { hourly: 20, weekday: 68, weekend: 98, weekly: 413, monthly: 1275 },
  },
  {
    id: 'eagle-landscape',
    name: 'Eagle Landscape Trailer',
    manufacturer: 'Eagle',
    model: 'Open Landscape / Utility',
    year: null,
    category: 'Landscape',
    tag: null,
    image: '/trailers/real/eagle-1.jpg',
    gallery: ['/trailers/real/eagle-1.jpg', '/trailers/real/eagle-2.jpg'],
    gvwr: '2,990 lbs',
    gawr: '3,500 lbs',
    axles: 'Single axle',
    deck: 'Open flat deck · mesh sides',
    dimensions: 'Standard single-axle landscape deck',
    payload: '2,000 lbs max',
    bestFor: ['Yard debris & brush', 'Landscaping crews', 'ATVs', 'Loose material'],
    features: [
      'High expanded-metal mesh sides',
      'Solid front, rear access ramp/gate',
      'Tongue jack + safety chains',
      'White modular wheels',
      'Red side markers & reflectors',
      'Easy load / unload',
    ],
    pricing: { hourly: 20, weekday: 60, weekend: 90, weekly: 375, monthly: 1125 },
  },
];

export const categories = ['All', 'Car Hauler', 'Cargo', 'Utility', 'Landscape'];

export const features = [
  {
    icon: 'ShieldCheck',
    title: 'Fully Equipped',
    description: 'Every trailer comes with winches, straps, chains, ramps — no last-minute hardware runs.',
  },
  {
    icon: 'Clock',
    title: 'Same-Day Rentals',
    description: 'Need it now? We offer same-day pickup and flexible hourly rentals starting at just $20/hour.',
  },
  {
    icon: 'MapPin',
    title: 'Local Pickup',
    description: 'Based at 3920 113th Ave SW in Olympia. Serving the greater Puget Sound & Pacific Northwest.',
  },
  {
    icon: 'Wallet',
    title: 'Fair, Flat Pricing',
    description: 'Transparent hourly, daily, weekly, and monthly rates. Deposit refunded at return.',
  },
  {
    icon: 'Sparkles',
    title: 'Clean & Well-Maintained',
    description: 'Every trailer is inspected before rental. Clean, safe, road-ready — every time.',
  },
  {
    icon: 'PhoneCall',
    title: 'Real Human Support',
    description: 'Talk to Jason directly. Fast responses, honest advice, hands-on help hooking up.',
  },
];

export const steps = [
  {
    n: '01',
    title: 'Pick Your Trailer',
    description: 'Browse our fleet and find the right trailer for your job — car hauler, cargo, utility, or landscape.',
  },
  {
    n: '02',
    title: 'Reserve Online',
    description: 'Send us your dates and details. We\'ll confirm availability within the hour.',
  },
  {
    n: '03',
    title: 'Pick Up in Olympia',
    description: 'Come by 3920 113th Ave SW in Olympia. We\'ll help hook up and walk you through everything.',
  },
  {
    n: '04',
    title: 'Haul & Return',
    description: 'Do the job, bring it back clean, and get your deposit back. Simple, honest, done.',
  },
];

export const requirements = [
  'Valid U.S. driver\'s license',
  'Valid auto insurance',
  'Valid credit card for deposit',
  '$50 booking fee (applied to your total)',
  'A tow vehicle in good working condition',
  'Must be 21 or older to rent',
];

export const reviews = [
  {
    name: 'Marcus T.',
    initials: 'MT',
    rating: 5,
    date: '2 weeks ago',
    text: 'Jason was fantastic. Helped me hook up the C4X car hauler and made sure everything was safe before I hit the road. Trailer was spotless, winch worked perfectly, and pricing beat everyone in Olympia. Highly recommend.',
  },
  {
    name: 'Danielle K.',
    initials: 'DK',
    rating: 5,
    date: '1 month ago',
    text: 'Rented the Continental enclosed for a cross-town move. Came with dollies and moving blankets — huge time saver. Booking was easy, pickup was smooth, and the price beat U-Haul by a mile.',
  },
  {
    name: 'Ryan P.',
    initials: 'RP',
    rating: 5,
    date: '3 weeks ago',
    text: 'Needed the MAXX-D last minute for a project truck. Called at 8am, had it by 10am. Trailer was in top shape and Jason clearly cares about his gear. Will absolutely rent again.',
  },
  {
    name: 'Aisha M.',
    initials: 'AM',
    rating: 5,
    date: '2 months ago',
    text: 'Used the Eagle landscape trailer to haul yard debris and a couple of ATVs. Simple, sturdy, and fairly priced. Loved that they offer hourly rentals — perfect for a half-day project.',
  },
  {
    name: 'Ben W.',
    initials: 'BW',
    rating: 5,
    date: '1 week ago',
    text: 'Best trailer rental experience I\'ve had. Local business, real communication, fair prices. The C4X handled two classic cars without a hitch.',
  },
  {
    name: 'Carla R.',
    initials: 'CR',
    rating: 5,
    date: '5 weeks ago',
    text: 'Straightforward, professional, and reasonably priced. Jason answered every question I had, no pressure sales. The Olympic utility was exactly what we needed.',
  },
];

export const faqs = [
  {
    q: 'How do I reserve a trailer?',
    a: 'Reserve online through our booking form or call/text Jason directly at (360) 500-2004. A $50 booking fee holds your rental and is applied to your total at pickup.',
  },
  {
    q: 'What do I need to rent?',
    a: 'A valid driver\'s license, valid auto insurance, a credit card for deposit, and a tow vehicle in good working condition rated for the trailer\'s GVWR. Renters must be 21 or older.',
  },
  {
    q: 'Do you offer same-day rentals?',
    a: 'Yes! Availability permitting, we offer same-day rentals with hourly, 24-hour, weekly, and monthly rates. Call ahead to confirm the trailer you need is on the lot.',
  },
  {
    q: 'Is there a deposit?',
    a: 'Yes, we hold a refundable deposit on your credit card. It\'s returned in full when the trailer is returned undamaged with all included equipment.',
  },
  {
    q: 'What areas do you serve?',
    a: 'Based in Olympia, WA. We serve the greater Puget Sound and Pacific Northwest, including Tacoma, Lacey, Tumwater, Centralia, and surrounding areas. Pickup is at our Olympia location.',
  },
  {
    q: 'What happens if the trailer gets damaged?',
    a: 'Minor wear is expected. Any new damage or missing equipment is deducted from the deposit at fair-market repair cost. We\'ll always walk through it together at return.',
  },
  {
    q: 'Can I extend my rental?',
    a: 'Absolutely — just call or text before your return time. As long as the trailer isn\'t booked, we\'re happy to extend. Additional time is billed at standard rates (late fees apply if unannounced).',
  },
];

export const stats = [
  { value: '500+', label: 'Happy Renters' },
  { value: '4', label: 'Trailer Types' },
  { value: '5.0', label: 'Google Rating' },
  { value: '7 Days', label: 'Open Every Week' },
];

export const RENTAL_AGREEMENT_URL =
  'https://customer-assets-agu9un31.emergentagent.net/job_fleet-showcase-20/artifacts/xz1e57r4_NW%20rentals%20LLC%20Agreement.pdf';
